'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('Viewer', ['Role', function (Role) {
    class Viewer extends Role {
        
    }

    return Viewer.newFrozenInstance(
        'ListClusters',
        'ListOrders',
        'ListOrderComments',
        'ListOrderTasks',
        'ShowOrderTask',
        'ListOrderLineItems',
        'ListLineItemComments',
        'ListLineItemTasks',
        'ShowLineItemTask'
    )
}]);